import request from '../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings/collection-fee';

export type CollectionFeeMode =
  | 'capitalPercentage'
  | 'fixedAmount'
  | 'percentageAndAmount';

export type DateClashCode = 'FUTURE_VALID_FROM_TAKEN' | 'ACTIVE_CONFIG_TODAY';

export interface CollectionFeeRuleItem {
  id: number;
  mode: CollectionFeeMode;
  percentage: number | null;
  amount: number | null;
  /** Moneda del monto fijo; null = moneda principal del tenant. */
  currencyId: number | null;
  currencyCode: string | null;
  /** null = fila anterior al rework por ítem (rige el setting global). */
  capitalizes: boolean | null;
  overdueDays: number;
  validFrom: string;
  isActive: boolean;
  isEditable: boolean;
}

export interface CollectionFeeOverview {
  items: CollectionFeeRuleItem[];
}

export interface CollectionFeePayload {
  mode: CollectionFeeMode;
  percentage?: number;
  amount?: number;
  /** Id del catálogo de monedas; ausente = moneda principal. */
  currencyId?: number;
  capitalizes: boolean;
  overdueDays: number;
  validFrom: string;
  /** Confirma el choque de fecha reportado por un 409 previo. */
  confirm?: boolean;
}

/** Cuerpo del 409 de choque de fecha: la config vigente para el antes/después. */
export interface CollectionFeeClashError {
  code: DateClashCode;
  current: CollectionFeeRuleItem;
}

export function getCollectionFees() {
  return request<CollectionFeeOverview>(BASE);
}

export function createCollectionFeeRule(body: CollectionFeePayload) {
  return request<CollectionFeeRuleItem>(BASE, { method: 'post', data: body });
}

export function updateCollectionFeeRule(id: number, body: CollectionFeePayload) {
  return request<CollectionFeeRuleItem>(`${BASE}/${id}`, {
    method: 'put',
    data: body,
  });
}

export function deleteCollectionFeeRule(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
